import con from '../../../../../connection';
var path = '/name';
var name = function (url) { return function () { return ({
    post: function (param) {
        return con.post(url + path, param);
    },
}); }; };
export default name;
